<template>
  <nav
      class="z-40 flex flex-col flex-wrap items-stretch justify-between w-full border-b border-gray-500 navbar-expand-lg"
      >
        <div
          class="flex flex-wrap items-center justify-between w-full px-2 py-3 mx-0 bg-gray-300"
        >
          <div
            class="relative flex justify-between w-full lg:w-auto lg:static lg:block lg:justify-start"
          >
            <!-- Site Title -->
            <a
              class="inline-block py-2 mr-4 text-sm font-bold leading-relaxed text-gray-700 uppercase whitespace-no-wrap cursor-pointer"
              @click="$router.push({name: 'Home'})">
                <img class="h-10" src="../assets/img/logo.png" alt="">
            </a>
            <!-- Sandwitch -->
            <button
              id="sandwitch"
              class="block px-3 py-1 text-xl leading-none bg-transparent border border-transparent border-solid rounded outline-none cursor-pointer lg:hidden focus:outline-none"
              type="button"
              v-on:click="toggleNavbar()"
            >
              <i class="text-gray-700 fas fa-bars"></i>
            </button>
          </div>

          <!-- Menu items -->
          <div
            class="items-center flex-grow lg:flex lg:bg-transparent lg:shadow-none"
            :class="{'hidden': !showMenu, 'block': showMenu}"
          >
            <ul class="flex flex-col items-stretch justify-between list-none lg:flex-row lg:ml-auto">
              <li v-for="(category, index) in menuItems" :key="index+'category'" class="flex">
                <dropdown-component
                  :name="category.name"
                  :items="category.subItems"
                  :index="index"
                  :right="index < menuItems.length-2"
                  class="flex"
                />
              </li>
            </ul>
          </div>
        </div>

      </nav>
</template>
<script>
import DropdownComponent from './Dropdown.vue';

import { busEvents, bus } from '../eventBus';
import * as data from '../assets/json/data.json';

export default {
  data() {
    return {
      showMenu: false,
      menuItems: data.menuItems,
      subMenuItems: [],
    };
  },
  components: {
    DropdownComponent,
  },
  methods: {
    toggleNavbar() {
      bus.$emit(busEvents.CLOSE_ALL_OTHER_DROPDOWNS, '');
      this.showMenu = !this.showMenu;
    },
  },
  computed: {
    showSubMenuItems() {
      return this.subMenuItems.length != 0;
    },
  },
  watch: {
    $route() {
      this.showMenu = false;
    },
  },
  mounted() {
    // bus.$on(busEvents.CLOSE_ALL_OTHER_DROPDOWNS, () => {
    //   this.showMenu = false;
    // });
    // Prevents click propogation of sandwitch to allow sandwitch to open
    document.body.querySelector('#sandwitch').addEventListener('click', (event) => {
      event.stopPropagation();
    });

    // Hides the menu and folds up the dropdowns
    document.body.addEventListener('click', () => {
      this.showMenu = false;
      bus.$emit(busEvents.CLOSE_ALL_OTHER_DROPDOWNS, '');
      bus.$emit(busEvents.CLOSE_ALL_OTHER_SUB_DROPDOWNS, '');
    });
  },
};
</script>
